module.exports = __webpack_public_path__ + "img/faq-grid-02.7f5c4764.png";